<template>
  <main class="profile">
    <div class="col-sm-8 mx-auto">
      <h1 class="display-2">Profile</h1><hr>
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label>Nom utilisateur</label>
          <vue-tel-input v-model="payload.owner.phone" :disabledFormatting="true" :preferredCountries="['bj']" disabled></vue-tel-input>
        </div>
        <div class="form-group">
          <label>Nom complet</label>
          <input type="text" class="form-control" v-model="payload.name">
        </div>
        <div class="form-group">
          <label>Email</label>
          <input type="text" class="form-control" v-model="payload.email">
        </div>
        <div class="form-group">
          <label>Adresse</label>
          <input type="text" class="form-control" v-model="payload.address">
        </div>
        <div class="form-group">
          <span class="btn-link" @click="toggled = !toggled">Code transfert</span>
          <div class="form-row my-2" v-show="toggled">
            <div class="col-sm-6"><input type="password" class="form-control" v-model="payload.repeat" placeholder="Ancien code"></div>
            <div class="col-sm-6"><input type="password" class="form-control" v-model="payload.secode" placeholder="Nouveau code"></div>
            <small class="form-text text-muted">Your code must be 4-6 characters long, contain only numbers, and must not contain any letters, spaces, special characters, or emoji.</small>
          </div>
        </div>
        <div class="form-group">
          <button type="submit" :class="[{ 'disabled': loading }, 'btn btn-warning btn-lg']">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading"></span>
            Valider
          </button>
        </div>
      </form>
    </div>
  </main>
</template>

<script>

export default {
  name: 'profile',
  data() {
    return {loading: false, error: false, payload: { ...this.$store.getters.loggedAs }, toggled: false}
  },
  /* computed: {
    toggled: {
      get: function () {
        return this.payload.secode !== ''
      },
      set: function (e) {
        if(e) this.payload.secode = ''
        else this.payload.secode = '...'
      }
    } 
  },*/
  methods: {
    onSubmit() { 
      this.loading = true; this.$store
      .dispatch('profile', this.payload)
      .then(() => this.$router.push({name: 'ross'}))
      .catch(() => this.error = 'Erreur de connexion.')
      .finally(() => this.loading = false)
    }
  },
}
</script>

<style scoped lang="scss">

</style>
